/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespHeroCarousel_item = {|
  +title: ?string;
  +photos: ?$ReadOnlyArray<?{|
    +largePath: ?string;
    +masterOrZoomPath: ?string;
    +alt: ?string;
  |}>;
  +canShowViewInRoom: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarousel_item",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarouselRequestMoreImages_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespZoomModal_item",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "title",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "largePath",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "masterOrZoomPath",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "alt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "canShowViewInRoom",
      "storageKey": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
